module.exports = __webpack_public_path__ + "static/img/007.b88e9a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/awards/007.png
// module id = jzTf
// module chunks = 0